var React = require('react');

function PersonFil (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 11.6667C16.5773 11.6667 18.6667 9.57737 18.6667 7.00004C18.6667 4.42271 16.5773 2.33337 14 2.33337C11.4227 2.33337 9.33334 4.42271 9.33334 7.00004C9.33334 9.57737 11.4227 11.6667 14 11.6667Z","stroke":"#121212","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M24.5 25.6666C24.5 19.8677 19.799 15.1666 14 15.1666C8.20102 15.1666 3.5 19.8677 3.5 25.6666","stroke":"#121212","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

PersonFil.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = PersonFil;

PersonFil.default = PersonFil;
